import TaskImportance from '../store/schema/TaskImportance';

export default function isImportant(importance: TaskImportance): boolean {
    return importance === TaskImportance.High;
}
